<template>
  <div class="my-container">
    <!-- ✅ Section Explorer -->
    <section class="explore-section">
      <h1 class="explore-title">🚀 Explorez Nos Ressources</h1>
      <p class="explore-subtitle p-header">
        Découvrez une variété de contenus éducatifs et produits inspirants.
      </p>

      <div class="categories">
        <NuxtLink to="/courses" class="category-card">
          <div class="category-icon">
            <i class="fas fa-chalkboard-teacher"></i>
          </div>
          <div class="category-content">
            <h3>Formations</h3>
            <p>Apprenez avec nos cours interactifs.</p>
          </div>
        </NuxtLink>

        <NuxtLink to="/articles" class="category-card">
          <div class="category-icon">
            <i class="fas fa-newspaper"></i>
          </div>
          <div class="category-content">
            <h3>Articles</h3>
            <p>Explorez des analyses et réflexions enrichissantes.</p>
          </div>
        </NuxtLink>

        <NuxtLink to="/books" class="category-card">
          <div class="category-icon">
            <i class="fas fa-book"></i>
          </div>
          <div class="category-content">
            <h3>Livres</h3>
            <p>Plongez dans une sélection de livres inspirants.</p>
          </div>
        </NuxtLink>

        <NuxtLink to="/clothings/" class="category-card">
          <div class="category-icon">
            <i class="fas fa-tshirt"></i>
          </div>
          <div class="category-content">
            <h3>Mode</h3>
            <p>Découvrez des designs uniques et tendances.</p>
          </div>
        </NuxtLink>

        <NuxtLink to="/stationeries/" class="category-card">
          <div class="category-icon">
            <i class="fas fa-pencil-alt"></i>
          </div>
          <div class="category-content">
            <h3>Fournitures</h3>
            <p>Fournitures de qualité pour vos besoins quotidiens.</p>
          </div>
        </NuxtLink>

        <NuxtLink to="/crafts" class="category-card">
          <div class="category-icon">
            <i class="fas fa-paint-brush"></i>
          </div>
          <div class="category-content">
            <h3>Art & Design</h3>
            <p>Créations artisanales faites à la main avec passion.</p>
          </div>
        </NuxtLink>
      </div>
    </section>
  </div>
</template>
<style scoped>
/* ✅ Section Explorer */
.explore-section {
  text-align: center;
  margin: 50px auto;
  padding: 40px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.explore-title {
  font-size: 2.4rem;
  font-weight: bold;
  color: #ff5722; /* Orange vif, pour donner du contraste */

  margin-bottom: 10px;
}

.explore-subtitle {
  font-size: 1.2rem;
  color: #666;

  margin-bottom: 30px;
}

/* ✅ Grille des catégories */
.categories {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 25px;
  justify-content: center;
  max-width: 1100px;
  margin: auto;
}

/* ✅ Cartes de catégorie */
.category-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #ffffff, #f5f5f5);
  padding: 20px;
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: #1a1a1a;
  border: 2px solid transparent;
}

.category-card:hover {
  transform: translateY(-7px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  border-color: #ff4500;
  background: linear-gradient(135deg, #ffffff, #e8eaf6);
}

/* ✅ Icônes des catégories */
.category-icon {
  font-size: 2rem;
  color: #007bff;

  margin-bottom: 15px;
  transition: color 0.3s ease;
}

.category-card:hover .category-icon {
  color: #1a237e;
}

/* ✅ Contenu des catégories */
.category-content h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ff4500;
  margin-bottom: 5px;
}

.category-content p {
  font-size: 1rem;
  color: #666;
}

/* ✅ Bouton CTA */
.cta-button {
  display: inline-block;
  background: #ff4500;
  color: white;
  padding: 12px 25px;
  border-radius: 8px;
  font-size: 1.1rem;
  text-decoration: none;
  transition: background 0.3s, transform 0.2s;
  margin-top: 20px;
}

.cta-button:hover {
  background: #a12e0c;
  transform: scale(1.05);
}

/* ✅ Responsive */
@media (max-width: 768px) {
  .categories {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .explore-title {
    font-size: 2rem;
  }

  .explore-subtitle {
    font-size: 1rem;
  }
}
</style>